import { render, staticRenderFns } from "./UploadEditor.vue?vue&type=template&id=ebb8a8b6"
import script from "./UploadEditor.vue?vue&type=script&lang=js"
export * from "./UploadEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports